<template>
    <b-card>
        <div slot="header">
          <i class="fa fa-list-ul" aria-hidden="true"></i>
            {{text.permissionList}}
          <div class="card-header-actions">
            <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
              <small class="text-muted">{{text.docs}}</small>
            </a>
          </div>
        </div>
        <b-row>
            <b-col sm="12">
                <alert-fail :show="messageError !== ''">{{ messageError }}</alert-fail>
                <!-- Username -->
                <form @submit.prevent="add">
                <b-form-group>
                    <label>{{text.permissionName}}</label>
                    <b-input-group>
                        <b-input-group-append>
                            <b-button
                            variant="outline-secondary"
                            @click="add">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            {{text.add}}</b-button>
                        </b-input-group-append>
                        <b-input v-model="permission" :placeholder="text.pleaseInsertPermission"></b-input>
                    </b-input-group>
                </b-form-group>
                </form>

                <b-row>
                <transition-group name="list-complete">
                    <b-col
                    v-for="(item, index) in items"
                    v-bind:key="item.id"
                    class="list-complete-item"
                    >
                    <i class="fa fa-key" aria-hidden="true"></i> | {{ item.name }}
                    <b-button variant="ghost-danger" @click="remove(index)" size="sm">
                        <i class="fa fa-times" aria-hidden="true"></i>
                        Delete</b-button>
                    </b-col>
                </transition-group>
                </b-row>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import AlertFail from '../../components/alert/AlertFail';
import { textUser } from '@/assets/utils/language';

export default {
  data () {
    return {
      items: [],
      permission: '',
      messageError: '',
      text: {}
    };
  },
  methods: {
    add () {
      this.axios.post(process.env.VUE_APP_ACCESS_CONTROL_URL + '/permission', { 'name': this.permission })
        .then(response => {
          const data = response.data.data;
          if (data.permission) {
            this.items.push({
              id: data.permission.id,
              name: data.permission.name
            });
          }
        })
        .catch(error => {
          this.handleError(error);
        })
        .finally(() => {
          this.permission = '';
        });
    },
    remove (index) {
      this.axios.delete(process.env.VUE_APP_ACCESS_CONTROL_URL + '/permission/' + this.items[index].id)
        .then(response => {
          this.items.splice(index, 1);
        })
        .catch(error => {
          this.handleError(error);
        });
    },
    getPermissionList () {
      this.axios.get(process.env.VUE_APP_ACCESS_CONTROL_URL + '/permission')
        .then(response => {
          const data = response.data.data;
          if (data.permissions) {
            const permissions = data.permissions;
            for (const permission of permissions) {
              this.items.push({
                id: permission.id,
                name: permission.name
              });
            }
          }
        })
        .catch(error => {
          this.handleError(error);
        });
    },
    handleError (error) {
      this.messageError = error.response.data || error.message;
    }
  },
  mounted () {
    this.getPermissionList();
    this.text = textUser(this.$language);
  },
  watch: {
    $language: function () {
      this.text = textUser(this.$language);
      this.refreshFields();
    }
  },
  components: {
    AlertFail
  }
};
</script>

<style scoped>
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
